import plusButton from '../../images/icons/plus-icon.png'
import Tooltip from "../../components/common/Tooltip";
import IconButton from "./IconButton";

/**
 * De plusknop onder een tabel: de enige manier om in die tabel een rij toe te
 * voegen. Gebruikt in 11 tabellen (team, rollen, locaties, taken, media, …).
 *
 * Dit was een `<img>` met een `onClick`, met de betekenis alleen in de tooltip.
 * Twee gevolgen: hij was niet met het toetsenbord te bereiken, en de tooltip
 * kent alleen muis-handlers, dus voor een schermlezer of op een aanraakscherm
 * had de knop geen naam. Nu is het een echte `<button>` met een `aria-label`,
 * en is het plusje zelf decoratief. De tooltip blijft voor de muisgebruiker.
 * AI-CONTEXT: See docs/pitfalls.md#ui-hover-only-affordance-dies-on-mobile
 *
 * @param {object} props
 * @param {string} props.toolTipContent - Wat de knop doet; tooltip én toegankelijke naam
 * @param {() => void} props.onClick - Aangeroepen bij klik of toetsenbordbediening
 */
const AddItemTableRow = ({toolTipContent, onClick}) => {

  return (
    <div className='add-item-table-row-container'>
         <Tooltip content={toolTipContent} width={'150px'} left='-10px' top={'-75px'}>
            <IconButton icon={plusButton} label={toolTipContent} onClick={onClick} />
        </Tooltip>
    </div>
  )
}

export default AddItemTableRow
